module.exports = __webpack_public_path__ + "static/media/cvc.f245592b.svg";